import BaseModel from "../base/BaseModel.model";
export default class Membertype extends BaseModel {
  public id: number = 0;
  public name: string = "";
  public isUniqueInPorposal: boolean = false;
  public isTheResponsableMember: boolean = false;
  
  public  isLimitProposal:boolean =false;
  public  quantity?:number|null;

  init() {
    this.id = 0;
    this.isUniqueInPorposal = false;
    this.isTheResponsableMember = false;
    this.name = "";
    this.quantity = 0;
    this.isLimitProposal = false;
  }
}
